import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import AppViewLogin from "@/views/AppLogin";

import store, {history} from "@/redux/store";
import { connect } from "react-redux";

const PublicRoute = ({...props}) => {
        const location = useLocation();

//    if(props && props.AuthReducer && props.AuthReducer.isAuth) {
    
//    return <Navigate to="/dashboard" />;
//    }
    if(props?.APP_PART !== true) {
       return <Navigate to="/dashboard" />; 
    }
    
    return (
        <>
        <AppViewLogin authReducer={props.AuthReducer}>
        <Outlet/>
        </AppViewLogin>
        </>
        ); 
}

function mapStateToProps(state) {
    const {AuthReducer, routing,ModalPopupReducer} = state
  return {
        AuthReducer,
        routing,
        ModalPopupReducer
  };
}
export default connect(mapStateToProps)(PublicRoute);
